/**
 * 会社の色を、この端末に覚えておく（ログインの画面を会社の色で出すため・総点検 M1）。
 *
 * 会社ごとの表示設定（`GET /org/branding`）はログインしてからでないと読めないので、
 * そのままだとログインの画面だけが中立の灰色になり、アプリと管理画面で最初の画面の色がばらばらに
 * 見えます。一度ログインして読めた**色だけ**を覚えておき、次からはログインの画面もその色で出します。
 *
 * 覚えるのは色（例 `#e0312b`）だけです。会社名やお名前は覚えません（共用のパソコンで、
 * 次にお使いになる方に前の方の情報が見えないようにする・issue #184 L-2 と同じ考え方）。
 * ブラウザの設定で保存できないときは、覚えずに灰色のまま動きます。
 */
const KEY = 'field-chat-admin.brand-color';

/** 色の形（#RRGGBB）だけを受け付ける。ほかの値は覚えない・使わない。 */
const HEX = /^#[0-9a-fA-F]{6}$/;

/**
 * 会社の設定から読めた色を覚える。色の形でない値（色を外した会社・形の違う値）のときは、
 * 前に覚えた色を**消す**（会社が色を外したのに、ログインの画面だけ古い色で出続けないように）。
 * 設定を読めなかったとき（通信の失敗）は呼ばないこと。覚えた色が消えてしまうため。
 */
export function rememberBrandColor(colorSeed: unknown): void {
  try {
    if (typeof colorSeed === 'string' && HEX.test(colorSeed)) {
      window.localStorage.setItem(KEY, colorSeed);
    } else {
      window.localStorage.removeItem(KEY);
    }
  } catch {
    // 保存できないブラウザでは覚えない（色が灰色になるだけで、ほかの動きは変わらない）
  }
}

export function rememberedBrandColor(): string {
  try {
    const value = window.localStorage.getItem(KEY) ?? '';
    return HEX.test(value) ? value : '';
  } catch {
    return '';
  }
}
